// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2IXT1TrxhML1sVXG4LftMI","icon":"_2tYCao6AyHzjRdiFJ384l7","title":"_1V6Bro1HCdkaLntbC_rmpC","count":"vnDvhSBs6e8daHh0zwAks"};